module.exports = {
      id: "icons:paper-plane-usage",
      viewBox: "0 0 17 16",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#icons:paper-plane-usage",
      toString: function () {
        return this.url;
      }
    }